import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import axios from "axios";
// import { axiosIns } from '../../utils'
// Import Images
import dummyImg from "../../../../assets/images/users/user-dummy-img.jpg";

import
{
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";

import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../../Components/Common/DeleteModal";

//Import actions
import { getPayOrganizers as onGetPayOrganizer } from "../../../../store/actions";

//redux
import TableContainer from "../../../../Components/Common/TableContainer";
import { useSelector, useDispatch } from "react-redux";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../../axiosConfig";
import { isValidPhoneNumber } from "react-phone-number-input";
import { lireRoleSession } from "../../../../espace";

const OrganisateurAskPay = ( props ) =>
{
  const [ loading, setLoading ] = useState( true );

  const history = useHistory();
  const dispatch = useDispatch();
  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).accessToken
    : null;



  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    } );
    return dateObject;
  }


  const [ isEdit, setIsEdit ] = useState( false );
  const [ payOrganizers, setPayOrganizers ] = useState( [] );
  const [ payOrganizer, setPayOrganizer ] = useState( {} );

  //delete Conatct
  const [ deleteModal, setDeleteModal ] = useState( false );
  const [ deleteModalMulti, setDeleteModalMulti ] = useState( false );
  const [ modal, setModal ] = useState( false );
  const [ modalMotif, setModalMotif ] = useState( false );
  const [ isExportCSV, setIsExportCSV ] = useState( false );

  const [ reducerValue, forceUpdate ] = useReducer( ( x ) => x + 1, 0 );

  function handleClick ()
  {
    forceUpdate();
  }

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  const [ idConnected, setIdConnected ] = useState( null )
  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )

      if ( obj.data )
      {
        setIdConnected( obj.data.id )
      }
    }
  }

  useEffect( () =>
  {
    getSessionData();
  }, [] )



  const fetchListDemandePaie = useCallback( async () =>
  {
    try
    {
      // /listdemande/ est réservé à l'administration : l'organisateur
      // recevait un 403 et l'écran restait vide. Sa propre route existait,
      // et elle le restreint déjà à ses demandes côté serveur — plutôt que
      // de lui envoyer celles de tout le monde pour filtrer ensuite.
      const list_demande = await axiosInstance.get(
        roleSession === "ORGANISATEUR"
          ? `/getalldemandefororga/`
          : `/listdemande/`
      );
      // console.log( "list_demande: ", list_demande.data.data )
      if ( list_demande.status === 200 )
      {
        setPayOrganizers( list_demande.data.data );
      }
    } catch ( err )
    {
      console.error( "Échec de récupération des tickets: ", err );
      toast.error( "Échec de récupération des tickets." );
    }
    setLoading( false )

    // Le rôle décide de la route appelée : sans lui dans les dépendances, le
    // rappel garderait celle choisie au premier rendu.
  }, [ roleSession ] );

  useEffect( () =>
  {
    fetchListDemandePaie()
  }, [ fetchListDemandePaie ] );

  const [ showDataTable, setShowDataTable ] = useState( [] );
  useEffect( () =>
  {
    const payFiltered = payOrganizers.length > 0 ? payOrganizers.filter(
      ( demande ) => demande.statut === "EN ATTENTE"
    ) : [];

    const list = roleSession === "ORGANISATEUR" ?
      payFiltered.filter( item => item.organisateur === idConnected )
      : payFiltered
    setShowDataTable( list )
  }, [ payOrganizers, roleSession, idConnected ] );

  const toggle = useCallback( () =>
  {
    if ( modal )
    {
      setModal( false );
    } else
    {
      setModal( true );
    }
  }, [ modal ] );

  const handleOrganizerClick = useCallback(
    ( arg ) =>
    {
      const pay_organizer = arg;

      setPayOrganizer( {
        last_name_organisateur: pay_organizer.last_name_organisateur,
        first_name_organisateur: pay_organizer.first_name_organisateur,
        id: pay_organizer.id,
        montant: pay_organizer.montant,
        methode_paiement: pay_organizer.methode_paiement,
        telephone: pay_organizer.telephone,
        commentaire: pay_organizer.commentaire,
        date: pay_organizer.date,
        statut: pay_organizer.statut,
        organisateur: pay_organizer.organisateur,
        user_id: pay_organizer.user_id,
        motif: pay_organizer.motif,
      } );

      toggle();
    },
    [ toggle ]
  );

  const [ loadingChangeStatus, setLoadingChangeStatus ] = useState( false )
  const handleaccept = useCallback( ( id_demande ) =>
  {
    setLoadingChangeStatus( true )
    axiosInstance
      .put( `/motifdemande/?id=${ id_demande }`, {
        statut: "Accepter",
      } )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Demande de paie acceptée avec succès" );
        fetchListDemandePaie();
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de l'acceptation de la demande de paie" );
      } );
    setLoadingChangeStatus( false )

  } );

  const handlerefuse = useCallback( ( id_demande, motif ) =>
  {
    setLoadingChangeStatus( true )
    axiosInstance
      .put( `/motifdemande/?id=${ id_demande }`, {
        statut: "Rejeter",
        motif: motif,
      } )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "La demande de paie rejetée avec succès" );
        fetchListDemandePaie();
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors du rejet de la demande." );
      } );
    setLoadingChangeStatus( false )
  }, [] );

  const validationRefuse = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      motif_refuse: "Pas de motif !",
    },
    validationSchema: Yup.object( {
      motif_refuse: Yup.string().required( props.t( "Veuillez entrer un motif" ) ),
    } ),
    onSubmit: ( values ) =>
    {
      // console.log("Motif de la désactivation: ", values.motif_refuse);
      // console.log("Compte désactivé: ", payOrganizer.id);

      handlerefuse( payOrganizer.id, values.motif_refuse );

      setModalMotif( false );
      setPayOrganizer( null );
    },
  } );


  const columns = useMemo(
    () => [
      {
        Header: props.t( "Nom" ),
        accessor: "last_name_organisateur",
        filterable: false,
      },
      {
        Header: props.t( "Prénom" ),
        accessor: "first_name_organisateur",
        filterable: false,
      },
      {
        Header: props.t( "Methode de paiement" ),
        accessor: "methode_paiement",
        filterable: false,
      },
      {
        Header: props.t( "Numero" ),
        accessor: "telephone",
        filterable: false,
      },
      {
        Header: props.t( "Montant" ),
        accessor: "montant",
        filterable: false,
      },
      {
        Header: props.t( "Commentaire" ),
        accessor: "commentaire",
        filterable: false,
      },
      {
        Header: props.t( "Statut" ),
        accessor: "statut",
        filterable: false,
        Cell: ( organizer ) => (
          <span
            className={
              organizer.row.original.statut === "Accepter"
                ? "badge badge-soft-success me-1"
                : organizer.row.original.statut === "Rejeter"
                  ? "badge badge-soft-danger me-1"
                  : "badge badge-soft-warning me-1"
            }
          >
            { organizer.row.original.statut }
          </span>
        ),
      },
      ...( roleSession !== "ORGANISATEUR"
        ? [
          {
            Header: props.t( "Motif/Action" ),
            accessor: "motif",
            filterable: false,
            Cell: ( cellProps ) =>
            {
              const clientData = cellProps.row.original;
              return (
                <ul className="list-inline hstack gap-2 mb-0">
                  { clientData.statut === "Rejeter" ? (
                    <li className="list-inline-item">
                      <p className="align-center">
                        <b>Motif: </b> { cellProps.row.original.motif }
                      </p>
                    </li>
                  ) : clientData.statut === "Accepter" ? (
                    <li className="list-inline-item">
                      <p className="align-center">
                        <b>Date: </b> { formatDate( cellProps.row.original.updated_at ) }
                      </p>
                    </li>
                  ) : (
                    <>
                      <li className="list-inline-item" title={ props.t( "Rejeter" ) }>
                        <Button
                          disabled={ loadingChangeStatus }
                          className="btn btn-sm btn-danger d-inline-block"
                          onClick={ ( e ) =>
                          {
                            e.preventDefault();
                            const organizerData = cellProps.row.original;
                            // console.log( 'organizerData refuse: ', organizerData )

                            handleOrganizerClick( organizerData );
                            setModalMotif( true );
                          } }
                        >
                          { loadingChangeStatus && <Spinner /> }
                          <i className="ri-close-line align-bottom"></i> Rejeter
                        </Button>
                      </li>
                      <li className="list-inline-item" title={ props.t( "Accepter" ) }>
                        <Button
                          disabled={ loadingChangeStatus }
                          className="btn btn-sm btn-success d-inline-block"
                          onClick={ ( e ) =>
                          {
                            e.preventDefault();
                            const demandeDataId = cellProps.row.original.id;
                            // console.log( 'demandeDataId: ', demandeDataId )
                            handleaccept( demandeDataId );
                          } }
                        >
                          { loadingChangeStatus && <Spinner /> }
                          <i className="ri-check-line align-bottom"></i> Accepter
                        </Button>
                      </li>
                    </>
                  ) }
                </ul>
              );
            },
          },
        ]
        : [] ),
    ],
    [ handleOrganizerClick, setModalMotif, roleSession, loadingChangeStatus ]
  );



  const [ modalAddDemande, setModalAddDemande ] = useState( false )
  const [ loadingAddDemande, setLoadingAddDemande ] = useState( false )

  const validationPaieAdd = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      montant: "",
      methode_paiement: "",
      event: "",
      telephone: "",
      commentaire: "",
    },
    validationSchema: Yup.object( {
      montant: Yup.number().required( props.t( "Veuillez entrer le montant" ) ),
      methode_paiement: Yup.string().required( props.t( "Veuillez entrer une méthode de paie" ) ),
      // event: Yup.string().required( props.t( "Veuillez selectionner un événement" ) ),
      telephone: Yup.string().required( props.t( "Veuillez entrer le numero de téléphone" ) ).test(
        "is-valid-phone",
        props.t( "Numéro de téléphone invalide" ),
        ( value ) => isValidPhoneNumber( value )
      ),
      commentaire: Yup.string().required( props.t( "Veuillez entrer un commentaire" ) )
    } ),
    onSubmit: async ( values ) =>
    {
      setLoadingAddDemande( true )
      console.log( "values: ", values );

      try
      {
        const res = await axiosInstance.post( "/createdemandepaiement/", values );
        if ( res.status === 200 )
        {
          console.log( "res submit: ", res );
          console.log( res.data );
          toast.success( ( "Demande envoyées avec succès" ), {
            autoClose: 3000,
          } );

        } else
        {
          toast.error( ( "Erreur lors de l'envoi de la demande" ), {
            autoClose: 3000,
          } );
        }
      } catch ( error )
      {
        console.error( "Erreur lors de l'envoi de la demande. Erreur: ", error );
        toast.error( ( "Erreur lors de l'envoi de la demande" ), {
          autoClose: 3000,
        } );
      }

      setLoadingAddDemande( false )
      fetchListDemandePaie();
      setModalAddDemande( false );
    },
  } );

  document.title = props.t( roleSession === "ORGANISATEUR" ? "Demande de paies | Takci" : "Demande de paies des organisateurs | Takci" );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={ props.t( roleSession === "ORGANISATEUR" ? "Demande de paies" : "Demande de paies des organisateurs" ) }
            pageTitle="Takci"
          />
          <Row>
            {
              !loading && showDataTable.length > 0 &&
              <Col lg={ 12 }>
                <Card>
                  <CardHeader>
                    <div className="d-flex justify-content-end align-items-center">
                      {/* <h2>{props.t("Customers List")}</h2> */ }
                      <div className="flex-shrink-0">

                        {
                          (
                            <button
                              disabled={
                                showDataTable.length < 0
                              }
                              type="button"
                              className="btn"
                              style={ { color: "#eac22f" } }
                              onClick={ () => setIsExportCSV( true ) }
                            >
                              <i className="ri-file-download-line align-bottom me-1"></i>{ " " }
                              { props.t( "Export" ) }
                            </button>
                          )
                        }

                        {
                          roleSession === "ORGANISATEUR" &&
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={ () => setModalAddDemande( true ) }
                          >
                            Créer une demande
                          </button>
                        }
                      </div>
                    </div>{ " " }
                  </CardHeader>
                </Card>
              </Col>
            }

            <Col xxl={ 12 }>
              <Card id="organizerDemandeList">
                <CardBody className="pt-0">
                  <div>
                    { !loading ? (
                      showDataTable.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={ isExportCSV }
                            onCloseClick={ () => setIsExportCSV( false ) }
                            data={ showDataTable }
                          />

                          <TableContainer
                            columns={ columns }
                            data={
                              showDataTable
                            }
                            isGlobalFilter={ true }
                            isAddUserList={ false }
                            customPageSize={ 8 }
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleAdminClick={ handleOrganizerClick }
                            isAdminsFilter={
                              !( showDataTable && showDataTable.length > 0 )
                            }
                          />
                        </>
                      ) : (

                        <Col
                          lg="12"
                          className="p-4 border-top border-top-dashed text-center"
                        >
                          <h6 className="text-muted text-uppercase fw-semibold mb-3">
                            Aucune demande de paie pour l'instant
                          </h6>
                        </Col>
                      )
                    ) : (
                      <>
                        <div className="text-center my-3">
                          <Spinner color="#014c94" />
                          Chargement...
                        </div>
                      </>
                    ) }
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal
            id="showModalMotif"
            style={ { maxWidth: 800 } }
            isOpen={ modalAddDemande }
            centered
          >
            <ModalHeader className="bg-soft-info p-3">
              { props.t( "Faire une demande de paie" ) }
            </ModalHeader>

            <Form
              onSubmit={ ( e ) =>
              {
                e.preventDefault();
                validationPaieAdd.handleSubmit();
                return false;
              } }
            >
              <ModalBody>
                <Input type="hidden" id="id-field" />
                <Row className="g-2" g={ 2 }>
                  {
                    //   montant: "",
                    // methode_paiement: "",
                    // event: "",
                    // telephone: "",
                    // commentaire: "",
                  }
                  <Col lg={ 6 }>
                    <Label htmlFor="montant" className="form-label">
                      { props.t( "Montant" ) }{ " " }
                      <span style={ { color: "red" } }>*</span>
                    </Label>
                    <Input
                      type="number"
                      name="montant"
                      id="montant"
                      className="form-control"
                      placeholder={ props.t( "Entrez le montant" ) }
                      validate={ {
                        required: { value: true },
                      } }
                      onChange={ validationPaieAdd.handleChange }
                      onBlur={ validationPaieAdd.handleBlur }
                      value={ validationPaieAdd.values.montant || "" }
                      invalid={
                        validationPaieAdd.touched.montant &&
                          validationPaieAdd.errors.montant
                          ? true
                          : false
                      }
                    />
                    { validationPaieAdd.touched.montant &&
                      validationPaieAdd.errors.montant ? (
                      <FormFeedback type="invalid">
                        { validationPaieAdd.errors.montant }
                      </FormFeedback>
                    ) : null }
                  </Col>

                  <Col lg={ 6 }>
                    <Label htmlFor="methode_paiement" className="form-label">
                      { props.t( "Methode de paiement" ) }{ " " }
                      <span style={ { color: "red" } }>*</span>
                    </Label>
                    <Input
                      type="select"
                      name="methode_paiement"
                      id="methode_paiement"
                      className="form-control"
                      placeholder={ props.t( "Entrez le methode_paiement" ) }
                      validate={ {
                        required: { value: true },
                      } }
                      onChange={ validationPaieAdd.handleChange }
                      onBlur={ validationPaieAdd.handleBlur }
                      value={ validationPaieAdd.values.methode_paiement }
                      invalid={
                        validationPaieAdd.touched.methode_paiement &&
                          validationPaieAdd.errors.methode_paiement
                          ? true
                          : false
                      }
                    >
                      <option value="" selected disabled>Sélectionner la méthode de paie</option>
                      <option value="Mtn">Mtn</option>
                      <option value="Moov">Moov</option>
                      <option value="Celtis">Celtis</option>
                    </Input>

                    { validationPaieAdd.touched.methode_paiement &&
                      validationPaieAdd.errors.methode_paiement ? (
                      <FormFeedback type="invalid">
                        { validationPaieAdd.errors.methode_paiement }
                      </FormFeedback>
                    ) : null }
                  </Col>

                  {/* <Col lg={ 6 }>
                              <Label htmlFor="event" className="form-label">
                                { props.t( "Evénement" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                type="select"
                                name="event"
                                id="event"
                                className="form-control"
                                placeholder={ props.t( "Entrez le event" ) }
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validationPaieAdd.handleChange }
                                onBlur={ validationPaieAdd.handleBlur }
                                value={ validationPaieAdd.values.event || "" }
                                invalid={
                                  validationPaieAdd.touched.event &&
                                    validationPaieAdd.errors.event
                                    ? true
                                    : false
                                }
                              >
                                <option value="" selected disabled>Sélectionner un événement</option>
                              </Input>
          
                              { validationPaieAdd.touched.event &&
                                validationPaieAdd.errors.event ? (
                                <FormFeedback type="invalid">
                                  { validationPaieAdd.errors.event }
                                </FormFeedback>
                              ) : null }
                            </Col> */}

                  <Col lg={ 6 }>
                    <Label htmlFor="telephone" className="form-label">
                      { props.t( "Téléphone" ) }{ " " }
                      <span style={ { color: "red" } }>*</span>
                    </Label>
                    <Input
                      type="text"
                      name="telephone"
                      id="telephone"
                      className="form-control"
                      placeholder={ props.t( "Entrez le telephone" ) }
                      validate={ {
                        required: { value: true },
                      } }
                      onChange={ validationPaieAdd.handleChange }
                      onBlur={ validationPaieAdd.handleBlur }
                      value={ validationPaieAdd.values.telephone || "" }
                      invalid={
                        validationPaieAdd.touched.telephone &&
                          validationPaieAdd.errors.telephone
                          ? true
                          : false
                      }
                    />
                    { validationPaieAdd.touched.telephone &&
                      validationPaieAdd.errors.telephone ? (
                      <FormFeedback type="invalid">
                        { validationPaieAdd.errors.telephone }
                      </FormFeedback>
                    ) : null }
                  </Col>


                  <Col lg={ 6 }>
                    <Label htmlFor="commentaire" className="form-label">
                      { props.t( "Commentaire" ) }{ " " }
                      <span style={ { color: "red" } }>*</span>
                    </Label>
                    <Input
                      type="textarea"
                      name="commentaire"
                      id="commentaire"
                      className="form-control"
                      placeholder={ props.t( "Entrez le commentaire" ) }
                      validate={ {
                        required: { value: true },
                      } }
                      onChange={ validationPaieAdd.handleChange }
                      onBlur={ validationPaieAdd.handleBlur }
                      value={ validationPaieAdd.values.commentaire || "" }
                      invalid={
                        validationPaieAdd.touched.commentaire &&
                          validationPaieAdd.errors.commentaire
                          ? true
                          : false
                      }
                    />
                    { validationPaieAdd.touched.commentaire &&
                      validationPaieAdd.errors.commentaire ? (
                      <FormFeedback type="invalid">
                        { validationPaieAdd.errors.commentaire }
                      </FormFeedback>
                    ) : null }
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <div className="hstack gap-2 justify-content-end">
                  <Button
                    disabled={ loadingAddDemande }
                    type="button"
                    onClick={ ( e ) =>
                    {
                      e.preventDefault();
                      setModalAddDemande( false );
                      fetchListDemandePaie();
                    } }
                    className="btn-light"
                  >
                    { props.t( "Fermer" ) }
                  </Button>
                  {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetChauffeurs); }} > {props.t("Fermer")} </button> */ }
                  <Button
                    disabled={ loadingAddDemande }
                    type="submit"
                    className="btn btn-primary"
                    id="add-demande-btn"
                  // style={ { background: "#002437", color: "white" } }
                  >
                    {
                      loadingAddDemande && <Spinner size={ "sm" } />
                    }
                    <span className="ms-1">
                      Créer la demande
                    </span>
                  </Button>
                </div>
              </ModalFooter>
            </Form>
          </Modal>

          <Modal
            id="showModalMotif"
            style={ { maxWidth: 800 } }
            isOpen={ modalMotif }
            centered
          >
            <ModalHeader className="bg-soft-info p-3">
              { props.t( "Motif du rejet de la demande" ) }
            </ModalHeader>

            <Form
              onSubmit={ ( e ) =>
              {
                e.preventDefault();
                validationRefuse.handleSubmit();
                return false;
              } }
            >
              <ModalBody>
                <Input type="hidden" id="id-field" />
                <Row className="g-3">
                  <Col lg={ 12 }>
                    <div>
                      <Label htmlFor="motif_refuse" className="form-label">
                        { props.t( "Motif" ) }{ " " }
                        <span style={ { color: "red" } }>*</span>
                      </Label>
                      <Input
                        name="motif_refuse"
                        id="motif_refuse"
                        className="form-control"
                        placeholder={ props.t( "Entrez le motif" ) }
                        type="textarea"
                        validate={ {
                          required: { value: true },
                        } }
                        onChange={ validationRefuse.handleChange }
                        onBlur={ validationRefuse.handleBlur }
                        value={ validationRefuse.values.motif_refuse || "" }
                        invalid={
                          validationRefuse.touched.motif_refuse &&
                            validationRefuse.errors.motif_refuse
                            ? true
                            : false
                        }
                      />
                      { validationRefuse.touched.motif_refuse &&
                        validationRefuse.errors.motif_refuse ? (
                        <FormFeedback type="invalid">
                          { validationRefuse.errors.motif_refuse }
                        </FormFeedback>
                      ) : null }
                    </div>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <div className="hstack gap-2 justify-content-end">
                  <Button
                    type="button"
                    onClick={ ( e ) =>
                    {
                      e.preventDefault();
                      setModalMotif( false );
                      fetchListDemandePaie();
                    } }
                    className="btn-light"
                  >
                    { props.t( "Fermer" ) }
                  </Button>
                  {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetChauffeurs); }} > {props.t("Fermer")} </button> */ }
                  <Button
                    type="submit"
                    className="btn btn-primary"
                    id="add-motif-btn"
                    style={ { background: "#002437", color: "white" } }
                  >
                    Envoyer la Motif
                  </Button>
                </div>
              </ModalFooter>
            </Form>
          </Modal>

          <ToastContainer closeButton={ false } />
        </Container>
      </div>
    </React.Fragment>
  );
};

OrganisateurAskPay.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( OrganisateurAskPay ) );
